<script setup lang="ts">
import { onMounted, computed } from "vue";
import { RouterView } from "vue-router";
import { Analytics } from "@vercel/analytics/vue";
import { useUserStore } from "@/stores/useUserStore";
import { useErrorHandler } from "@/shared/composables/useErrorHandler";
import router from "@/router";
import { t } from "i18next";
import type { UserType } from "@/shared/types/Users/UserType";
import { preloadThirdPartyResources } from "@/shared/utils/optimizedScriptLoader";
import Unauthorized from "@/components/views/Exceptions/Unauthorized.vue";

const { errorState, resetAll } = useErrorHandler();
const show403 = computed(() => errorState.value.show403);

onMounted(() => {
	const { setUser, setUserType } = useUserStore();

	preloadThirdPartyResources(["s3.tradingview.com", "tradingview.com"]);

	for (const route of router.getRoutes()) {
		route.name = t(route.name as string);
	}

	const language = navigator.language.split("-")[0];
	document.documentElement.lang = language;

	const user = localStorage.getItem("user");
	if (user) setUser(JSON.parse(user));
	const userType = localStorage.getItem("userType") as UserType;
	if (userType) setUserType(userType);

	router.afterEach(() => {
		resetAll();
	});
});
</script>

<template>
  <Analytics />
  <Header />
  <main class="min-h-[60dvh] mb-[72px] lg:mb-0 py-4 md:py-8 relative px-2 md:px-4">
    <TVTickerTape class="absolute top-0 w-full -mx-2 md:-mx-4" />
    <MyBreadcrumb class="mt-[72px] md:mt-[44px]" />
    <Unauthorized v-if="show403" />
    <RouterView v-else />
    <Toaster />
    <Sonner />
    <GenerativeAI />
  </main>
  <Footer />
</template>
